import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchReferences } from '../modules/ReferenceList/actions';
import { isLoaded, getError } from '../modules/ReferenceList/reducer';
import ReferenceList from '../modules/ReferenceList';

class ReferenceListpage extends Component {
  componentDidMount() {
    this.props.fetchReferences();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Reference</h1>
            <Button tag={Link} to="/reference/new" color="primary">
              Nová reference
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <ReferenceList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchReferences }
)(ReferenceListpage);



// WEBPACK FOOTER //
// ./src/pages/ReferenceListPage.js